export default "__VITE_ASSET__iPw0PEgI__"